/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：308
 */

module.exports = {
  soundMallItem: "style_soundMallItem__1xXHP",
  selected: "style_selected__2cgIT",
  infoArea: "style_infoArea__tjcur",
  btn: "style_btn__A86-H",
  select: "style_select__1Guqn",
  unselect: "style_unselect__31nJ8",
  playArea: "style_playArea__60ZFm",
  soundPauseIconBox: "style_soundPauseIconBox__j8ekE",
  soundPauseIcon: "style_soundPauseIcon__1u4G8",
  progressWrapper: "style_progressWrapper__19a5n",
  rightWrapper: "style_rightWrapper__3xifr",
  leftWrapper: "style_leftWrapper__3KpG2",
  circleProgress: "style_circleProgress__3CT57",
  rightCircle: "style_rightCircle__24JP8",
  circleProgressLoad_right: "style_circleProgressLoad_right__3Pj3Q",
  leftCircle: "style_leftCircle__PhREJ",
  circleProgressLoad_left: "style_circleProgressLoad_left__1dx3o",
  soundIconBox: "style_soundIconBox__3Hcxe",
  soundPlayIconBox: "style_soundPlayIconBox__1vJtr",
  soundDefaultIcon: "style_soundDefaultIcon__14kHL",
  soundPlayIcon: "style_soundPlayIcon__3FJGn",
  duration: "style_duration__3TrsW",
  nameArea: "style_nameArea__KZyGn",
  add: "style_add__2mYND"
}
